/* eslint-disable */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { TranslateService } from '@ngx-translate/core';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';
import { MSLatLngPlace } from 'src/app/models/map.model';
import { LoggerService } from 'src/app/services/logger.service';
import { MapsService } from 'src/app/services/maps.service';
import { GeocodeUseCase } from 'src/app/use-case/bing-maps/geocode/geocode.use-case';
import { GeocodeEvent } from 'src/app/use-case/bing-maps/geocode/utils/geocode.utils';

export type AddressSearchResult = {
  location: MSLatLngPlace;
  hasValidAccuracy: boolean;
  type: 'select' | 'clear';
};

const HIDE_KEYBOARD_DELAY = 100;

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss']
})
export class AddressSearchComponent implements OnInit {
  @ViewChild('address-search-results')
  addressSearchResults: ElementRef;

  @Input() mapLoaded: any;
  @Output() addressSearchEvent = new EventEmitter<AddressSearchResult>();
  @Output() addressSearchResultUpdate = new EventEmitter<AddressSearchResult[]>();

  query = '';
  searchResults: any;
  result: any = {};
  searchPlaceholder: string;

  constructor(
    private translate: TranslateService,
    private logger: LoggerService,
    private maps: MapsService,
    private geocoder: GeocodeUseCase
  ) {
    this.searchPlaceholder = this.translate.instant('MAP_PLACE_SEARCH_SEARCH');
  }

  async selectResult(place) {
    const address = place.entityType == 'LocalBusiness' ? place.structured_formatting.secondary_text : place.description;

    this.hideKeyboard();
    this.searchResults = [];
    this.addressSearchResultUpdate.emit([]);
    this.maps.selectPlace(place);

    this.geocoder.execute(address).subscribe((response) => {
      if (response instanceof GeocodeEvent.Success) {
        const result: AddressSearchResult = {
          location: {
            name: response.address,
            lat: response.latitude,
            lng: response.longitude
          },
          hasValidAccuracy: response.hasValidAccuracy,
          type: 'select'
        };
        this.query = response.address;
        this.addressSearchEvent.emit(result);
      } else if (response instanceof GeocodeEvent.Error) {
        this.logger.log('Error in selecting place - survey geocoder', MSRemoteLoggerCategory.ADDRESS_SEARCH_COMPONENT);
      }
    });

    // .then(res => {
    //     this.result.location = res['location'];
    //     this.result.hasValidAccuracy = res['hasValidAccuracy'];
    //     this.result.type = 'select';
    //     this.query = this.result.location.name;
    //     this.addressSearchEvent.emit(this.result);
    // })
    // .catch(res => {
    //     this.logger.log("Error in selecting place - survey geocoder")
    // })
  }

  onSubmitSearch() {
    // if user clicks 'enter' key on keyboard, select the first result
    if (this.searchResults.length) {
      this.selectResult(this.searchResults[0]);
    }
  }

  search() {
    this.maps.searchPlace(this.query).then((res) => {
      const addressSearchResults = this.searchPlaceResultsToAddressSearchResults(res as any[]);

      this.searchResults = res;
      this.addressSearchResultUpdate.emit(addressSearchResults);
    });
  }

  onClearSearch() {
    this.query = ''; // clearing search triggers another ionInput event. need to clear query or search will continue to yield results
    this.searchResults = [];
    this.result.type = 'clear';
    this.addressSearchEvent.emit(this.result);
    this.addressSearchResultUpdate.emit([]);
    this.hideKeyboard();
  }

  hideKeyboard() {
    // Workaround for android map display bug
    if (Capacitor.isPluginAvailable('Keyboard')) {
      setTimeout(() => {
        Keyboard.hide();
      }, HIDE_KEYBOARD_DELAY);
    }
  }

  ngOnInit() {
    this.maps.showGeocoderInstructions();
  }

  private searchPlaceResultsToAddressSearchResults(searchPlaceResults: any[]): AddressSearchResult[] {
    return searchPlaceResults.map((searchPlaceResult) => this.seachPlaceResultToAddressSearchResult(searchPlaceResult));
  }

  private seachPlaceResultToAddressSearchResult(searchPlaceResult: any): AddressSearchResult {
    return {
      location: searchPlaceResult.location,
      hasValidAccuracy: searchPlaceResult.hasValidAccuracy,
      type: 'select'
    };
  }
}
